export default __webpack_public_path__ + "f228ac0fc52fb4539b0e40e1216b5dc7.svg";